import AiQuizHandler from './AiQuizHandler'

export default AiQuizHandler
